query GetPinnedContentsQuery ($filter: BannersFilter){
  contests(filter: { isPinned: true }) {
    edges {
      node {
        id
        picture
        background
        shortTitle
        title
        type
        slug
        year
        festival {
          id
          slug
        }
      }
    }
  }
  contestsToJudge: contests(filter: { isCurrentUserJudging: true }) {
    edges {
      node {
        id
        picture
        background
        shortTitle
        title
        type
        slug
        type
        year
      }
    }
  }
  banners(filter: $filter) {
    edges {
      node {
        isPublished
        id
        language
        picture
        text
        type
        target
      }
    }
  }
}
